import React, { Component } from "react";
import styled from "styled-components";

import Header from "./components/Header";
import BuyNowLinks from "./components/BuyNowLinks";
import Trailer from "./components/Trailer";
import Divider from "./components/Divider";
import WeaponsCarousel from "./components/WeaponsCarousel";
import CosmeticsCarousel from "./components/CosmeticsCarousel";

import mapAndAchievements from "./library/images/map-and-achievements.png";
import unclockableOutfit from "./library/images/unclockable-outfit.png";
import zedConomyUpdate from "./library/images/zed-conomy-update.png";
import springTickets from "./library/images/spring-tickets.png";
import fxBundle from "./library/images/fx-bundle.png";

class App extends Component {
  render() {
    return (
      <WidescreenStyle>
        <SiteWrapper>
          <Header />
          <BuyNowLinks />
          <Trailer />
          <TextWrapper>
            <p>
              Horzine’s development labs decked out the mercenaries with the
              latest Cyberpunk themed weaponry and gear! Slay Zeds and spread
              bloodshed while looking stylishly futuristic. Fend Zeds off at our
              new dam facility known as Spillway, and try out Horzine’s two new
              weapons, the Helios Rifle and the Killerwatt. See you on the
              killing floor!
            </p>
          </TextWrapper>
          <Divider />
          <TextWrapper>
            <h2>New Map and Achievements</h2>
            <h3>New Map: Spillway</h3>
            <ul>
              <li>
                Compatible with Survival, Weekly, VS Survival, and Endless Game
                Modes. Clear a dam facility overrun by those dam Zeds!
              </li>
            </ul>
          </TextWrapper>
          <TextWrapper>
            <div className="image">
              <img src={mapAndAchievements} alt="Map and Achievements" />
            </div>
          </TextWrapper>
          <TextWrapper>
            <h2>New Weapons</h2>
          </TextWrapper>
          <WeaponsCarousel />
          <TextWrapper>
            <h3>New Weapons: Helios Rifle for the Firebug</h3>
            <ul>
              <li>Two fire modes, automatic and 3-round burst fire</li>
              <li>
                Fires plasma balls that can penetrate through multiple Zeds and
                fry them up with microwave energy
              </li>
              <li>Trader price is 1500 Dosh</li>
            </ul>
            <h3>Killerwatt for the Survivalist</h3>
            <ul>
              <li>Two fire modes, automatic and overcharge</li>
              <li>
                Fires consecutive bolts of electricity or one charged stream of
                destructive voltage
              </li>
              <li>Trader cost is 2500 Dosh</li>
            </ul>
            <p>Battle Axe is now available to all players!</p>
          </TextWrapper>
          <TextWrapper>
            <h2>Unclockable Outfit</h2>
            <div className="image">
              <img
                src={unclockableOutfit}
                alt="Unclockable Outfit"
                style={{
                  border: "solid",
                  borderWidth: "2px",
                  borderColor: "#00fdef"
                }}
              />
            </div>
          </TextWrapper>
          <Divider />
          <TextWrapper>
            <img
              src={zedConomyUpdate}
              alt="Zed Conomy Update"
              style={{ width: "100%", height: "100%", marginTop: "60px" }}
            />
          </TextWrapper>
          <TextWrapper>
            <h2>Limited Time Tickets</h2>
            <img
              src={springTickets}
              alt="Spring Tickets"
              style={{ width: "100%", height: "100%" }}
            />
          </TextWrapper>
          <TextWrapper>
            <h2>New Cosmetics</h2>
          </TextWrapper>
          <CosmeticsCarousel />
          <TextWrapper style={{ marginBottom: "0", paddingBottom: "60px" }}>
            <h2>Headshot FX Bundle 2</h2>
            <div className="image">
              <img
                src={fxBundle}
                alt="FX Bundle"
                style={{
                  border: "solid",
                  borderWidth: "2px",
                  borderColor: "#00fdef"
                }}
              />
            </div>
          </TextWrapper>
        </SiteWrapper>
      </WidescreenStyle>
    );
  }
}

const WidescreenStyle = styled.div`
  background: linear-gradient(#3c0b5d, #030c6c, #3c0b5d);
`;

const SiteWrapper = styled.div`
  max-width: 1920px;
  margin: auto;

  h2,
  p,
  li {
    font-family: "Titillium Web", sans-serif;
    letter-spacing: 1px;
  }
`;

const TextWrapper = styled.div`
  margin: 40px 0;
  padding: 0 20vw;

  .image {
    display: flex;
    justify-content: center;
  }

  img {
    width: 70%;
    height: 70%;
  }

  h2 {
    font-family: "BICUBIK", sans-serif;
    font-size: 38px;
    letter-spacing: 3px;
    text-align: center;
    color: #fde704;
    text-shadow: 1px 1px #000000;
    padding: 5vh 0;
  }

  h3 {
    color: #fde704;
    text-shadow: 1px 1px black;
    text-align: left;
    padding: 5px;
    font-size: 18px;
  }

  a {
    color: #fde704;
    text-decoration: none !important;
  }

  a:hover {
    color: #fde704 !important;
    text-decoration: underline !important;
  }

  p,
  li {
    text-shadow: 1px 1px black;
    font-size: 16px;
    color: white;
    text-align: justify;
  }

  @media (max-width: 1608px) {
    padding: 0 15vw;
  }

  @media (max-width: 1378px) {
    padding: 0 10vw;
  }

  @media (max-width: 650px) {
    margin-bottom: 20px;
    padding: 0 5vw;

    img {
      width: 100%;
      height: 100%;
    }

    h2 {
      font-size: 21px;
      letter-spacing: 2px;
    }

    h3 {
      font-size: 15px !important;
    }

    p,
    li {
      text-align: left;
      font-size: 14px;
    }
  }
`;

export default App;
